import React, { useEffect, useState } from "react"

// Mui
import {
  alpha,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Stack,
  TextField,
  Typography,
  useTheme
} from "@mui/material"

// form
import { useForm, Controller } from "react-hook-form"
import ValidationHelperText from "../../../../common/validation-helper-text"
import commonServices from "../../../../../services/common"
import { toast } from "react-toastify"
import ticketServices from "../../../../../services/tickets"
import typesGroupHandler from "../../../../../lib/typeGroup"
import FileUploader from "src/components/common/file-uploader"

// ---------------------------------------------------------------------------------------------------------------------

const TicketCreateForm = ({ open, setOpen, list }) => {
  const key = "TicketType"

  const theme = useTheme()

  const [file, setFile] = useState()
  const [types, setTypes] = useState([])
  const [state, setState] = useState("loading" | "error" | "done")

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    clearErrors,
    control
  } = useForm()

  const closeDialog = () => {
    setOpen(perv => ({ ...perv, create: false }))
    reset()
    clearErrors()
  }

  const findTypesList = () => {
    typesGroupHandler.getGroupId(key).then(groupId => {
      commonServices.getTypeById(groupId).then(response => {
        if (response?.status === 200) {
          if (!response?.data?.succeed) {
            toast.error(response?.data?.message)
          } else {
            setTypes(response?.data?.value)
          }
        }
      })
    })
  }

  useEffect(() => {
    findTypesList()
  }, [])

  const handleCreateTicket = value => {
    setState("loading")
    const data = {
      PurchaseId: value?.purchaseId,
      Message: value?.message,
      Type: value?.type?.id,
      file
    }

    ticketServices
      .insertTicket(data)
      .then(response => {
        if (response?.status === 200) {
          if (!response?.data?.succeed) {
            setState("error")
            toast?.error(response?.data?.message)
          } else {
            setState("done")
            list()
            closeDialog()
            toast.success("درخواست پشتیبانی ثبت شد")
            toast.success(` کد رهگیری : ${response?.data?.value}`)
          }
        }
      })
      .catch(() => {
        setState("error")
      })
  }

  return (
    <Dialog open={open} fullWidth maxWidth='xs' onClose={closeDialog} PaperProps={{ sx: { borderRadius: "15px" } }}>
      <DialogContent>
        <Typography variant='h5'>ثبت درخواست پشتیبانی جدید</Typography>

        <form onSubmit={handleSubmit(handleCreateTicket)}>
          <Stack spacing={1} mt={3}>
            <Box>
              <Controller
                control={control}
                name='type'
                rules={{
                  required: {
                    value: true,
                    messages: "نوع درخواست پشتیبانی اجباری است"
                  }
                }}
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    onChange={(event, item) => {
                      onChange(item)
                    }}
                    value={value || ""}
                    options={types}
                    getOptionLabel={item => (item.name ? item.name : "")}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='نوع درخواست پشتیبانی'
                        sx={{
                          "& .MuiInputBase-root": {
                            borderRadius: "8px",
                            backgroundColor: alpha(theme.palette.grey[200], 0.5)
                          }
                        }}
                        inputProps={{
                          ...params.inputProps,
                          maxLength: 10
                        }}
                      />
                    )}
                  />
                )}
              />
              <ValidationHelperText error={errors?.type} helperText={errors?.type?.message} />
            </Box>
            <Box>
              <TextField
                {...register("purchaseId", {
                  required: {
                    value: false,
                    message: "شناسه خرید اجباری است"
                  }
                })}
                inputProps={{
                  maxLength: 20
                }}
                fullWidth
                name='purchaseId'
                label='شناسه خرید'
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "8px",
                    backgroundColor: alpha(theme.palette.grey[200], 0.5)
                  }
                }}
              />
              <ValidationHelperText error={errors?.purchaseId} helperText={errors?.purchaseId?.message} />
            </Box>
            <Box>
              <TextField
                {...register("message", {
                  required: {
                    value: true,
                    message: "پیام اجباری است"
                  }
                })}
                name='message'
                multiline
                rows={3}
                fullWidth
                label='پیام'
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "8px",
                    backgroundColor: alpha(theme.palette.grey[200], 0.5)
                  }
                }}
              />
              <ValidationHelperText error={errors?.message} helperText={errors?.message?.message} />
            </Box>
            <Box>
              <FileUploader setFile={setFile} title='ثبت تصویر' subTitle='تصویر را انتخاب کنید' />
            </Box>
          </Stack>
          <Stack mt={3} direction='row' justifyContent='end' alignItems='center' spacing={1}>
            <Button disabled={state === "loading"} variant='text' color='inherit' onClick={closeDialog}>
              بستن
            </Button>
            <Button
              type='submit'
              disabled={state === "loading"}
              variant='contained'
              sx={{ borderRadius: "8px", px: 3 }}
            >
              {state === "loading" ? <CircularProgress size={18} /> : "ثبت"}
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default TicketCreateForm
